export default __webpack_public_path__ + "fonts/7f7e3992e90b734875218848d6a15175.ttf";